module.exports = __webpack_public_path__ + "img/webBrand--billy-dash-short-wh.299a9c9f.svg";